import {
  CoreFintechUiComponents,
  CORE_FINTECH_UI_NAME,
} from "@b2bportal/core-types";
import FintechMarketplaceProductBreadcrumbListStyles from "./FintechMarketplaceProductBreadcrumbList.module.scss";
import FintechMarketplaceSectionStyles from "./FintechMarketplaceSection.module.scss";
import FintechProductStyles from "./FintechProduct.module.scss";
import FintechProductBulletStyles from "./FintechProductBullet.module.scss";
import FintechProductInfoLinksSectionStyles from "./FintechProductInfoLinksSection.module.scss";
import FintechProductOptionsSectionStyles from "./FintechProductOptionsSection.module.scss";
import HtsIFrameLoaderStyles from "./HtsIFrameLoader.module.scss";

export const CORE_FINTECH_UI_STYLE_OVERRIDES = {
  [CORE_FINTECH_UI_NAME]: {
    [CoreFintechUiComponents.FintechMarketplaceSection]:
      FintechMarketplaceSectionStyles,
    [CoreFintechUiComponents.FintechMarketplaceProductBreadcrumbList]:
      FintechMarketplaceProductBreadcrumbListStyles,
    [CoreFintechUiComponents.FintechProduct]: FintechProductStyles,
    [CoreFintechUiComponents.FintechProductBullet]: FintechProductBulletStyles,
    [CoreFintechUiComponents.FintechProductInfoLinksSection]:
      FintechProductInfoLinksSectionStyles,
    [CoreFintechUiComponents.FintechProductOptionsSection]:
      FintechProductOptionsSectionStyles,
    [CoreFintechUiComponents.HtsIFrameLoader]: HtsIFrameLoaderStyles,
  },
};
